import * as React from "react";
import { HRQuestionId } from "../../messages/ObjectIds";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion } from "../../messages/HR";
import "./GenericDoubleSliderInput.css";
import { StatusComponent } from "../widgets/StatusComponent";
import { Checkbox } from "@blueprintjs/core";

const ReactSlider: any = require("react-slider"); // tslint:disable-line:no-var-requires no-require-imports


interface GenericDoubleSliderInputProps {
    hrStartAndEndTimeQuestion: HRQuestionWithStatus<HRQuestion.StartAndEndTimeQuestion>;
    isHidden: boolean;
    onChange: (newVal: any | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericDoubleSliderInput extends React.Component<GenericDoubleSliderInputProps> {
    constructor(props: GenericDoubleSliderInputProps) {
        super(props);
    }

    hoursToDisplayTime(hours: number): string {
        if (hours === 12) {
            return hours + "PM";
        } else if (hours === 0 || hours === 24) {
            hours = 12;
            return hours + "AM";
        } else if (hours > 12) {
            hours = hours - 12;
            return hours + "PM";
        } else {
            return hours + "AM";
        }
    }


    handleCheckboxChange(val: { startTime: number, endTime: number } | null, id: HRQuestionId) {
        this.props.onChange(val, id);
        this.props.onBlur(id);
    }

    render() {
        const question = this.props.hrStartAndEndTimeQuestion.question;
        const status = this.props.hrStartAndEndTimeQuestion.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <div className={"GenericDoubleSliderInput__statusContainer"}>
                    <Checkbox
                        checked={question.answer !== null}
                        label={question.questionText}
                        onChange={
                            () => question.answer === null ? this.handleCheckboxChange({
                                startTime: 0,
                                endTime: 24
                            }, question.id) : this.handleCheckboxChange(null, question.id)
                        }
                        required={question.isMandatory}
                    />
                    <StatusComponent questionStatus={status}/>
                </div>
                {question.answer === null ?
                    ""
                    :
                    <div>
                        <ReactSlider
                            className="GenericDoubleSliderInput__slider"
                            max={24}
                            min={0}
                            minDistance={1}
                            value={[question.answer.startTime, question.answer.endTime]}
                            step={1}
                            onChange={(values: number[]) =>
                                this.props.onChange({
                                        startTime: values[0],
                                        endTime: values[1]
                                    },
                                    question.id)
                            }
                            snapDragDisabled={true}
                            withBars={true}
                            barClassName={"GenericDoubleSliderScreen__bar"}
                            onAfterChange={() => this.props.onBlur(question.id)}
                        >
                            <div className={"GenericDoubleSliderInput__handleStart"}>
                                {this.hoursToDisplayTime(question.answer.startTime)}
                            </div>
                            <div className={"GenericDoubleSliderInput__handleEnd"}>
                                {this.hoursToDisplayTime(question.answer.endTime)}
                            </div>
                        </ReactSlider>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericDoubleSliderInput.tsx